import React from 'react'

import { TextLoader } from 'shared/ui'
import { isEmpty } from 'util/objects'

import ConfirmPane from '../ConfirmPane'
import SelectTickets from '../SelectTickets'

// Renders either the ticket selection pane (default), or the brief
// confirmation modal after you select a ticket to merge.
const Switcher = props => {
  const {
    childTickets,
    confirmationSeconds,
    direction,
    onCancel,
    targetTicket,
    ticket,
    hidden,
  } = props

  if (!ticket || isEmpty(ticket)) return <TextLoader fullScreen />

  const childIsSameAsTarget =
    targetTicket &&
    childTickets &&
    childTickets.length === 1 &&
    childTickets[0].id === targetTicket.id

  if (targetTicket && childTickets && !childIsSameAsTarget) {
    return (
      <ConfirmPane
        childTickets={childTickets}
        confirmationSeconds={confirmationSeconds}
        direction={direction}
        onCancel={onCancel}
        targetTicket={targetTicket}
      />
    )
  }

  return <SelectTickets {...props} hidden={hidden} />
}

export default Switcher
